import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Refus de souffler dans l'alcootest – coupable automatiquement?"
            description="Être derrière le volant d’un véhicule alors que vous êtes en état d’ébriété peut vous mener à de lourdes conséquences. Cela est également vrai si vous refusez de souffler dans l’alcootest."
            fr={undefined}
            lawType="criminal"
            specialtyText="spécialisé en alcool au volant">
            <p>
                Si vous refusez de souffler dans l’alcootest après avoir été
                intercepté par un policier, vous serez tout de même accusé
                d’alcool au volant et vous recevrez les sanctions les plus
                strictes.
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Puis-je refuser de souffler dans l’alcootest?"
                    alt=""
                />
            </p>
            <p>
                Par conséquent, refuser de souffler dans l’alcootest est
                probablement la pire option. Il est préférable d’obtempérer en
                parlant le moins possible avec le policier.{' '}
            </p>
            <p>
                <strong>
                    Pour savoir comment vous défendre lors d’une accusation de
                    refus de souffler dans l’alcootest, lisez ce guide complet
                    offert par Avocats Alcool au Volant!
                </strong>
            </p>
            <h2>
                <strong>
                    À quel moment un policier peut-il exiger un alcootest?
                </strong>
            </h2>
            <p>
                Si le policier souhaite arrêter une personne pour conduite avec
                les facultés affaiblies ou l’apporter au poste de police, il
                doit avoir des motifs raisonnables de soupçonner que vous êtes
                en état d’ébriété.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Pas si vite! </strong>Depuis 2018,
                            l’exigence entourant le « motif raisonnable » n’est
                            plus nécessaire et donc, le fardeau reposant sur les
                            épaules du policier est moins élevé qu’il ne l’était
                            auparavant.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Même en l’absence de symptômes d’intoxication, le policier
                pourrait vous soumettre à un alcootest s’il a en sa possession
                l’outil permettant de prélever un échantillon d’haleine.
            </p>
            <p>
                Dès que vous êtes intercepté par un policier et que vous êtes au
                volant d’un véhicule, cet agent pourrait vous demander
                immédiatement de souffler dans son appareil de détection.
            </p>
            <h2>
                <strong>
                    Puis-je être accusé d’avoir refusé de souffler dans un
                    alcootest?
                </strong>
            </h2>
            <p>
                Oui, il est possible d’être accusé de « refuser de souffler ou
                d’obtempérer ». Lorsqu’un policier vous intercepte au volant
                d’un véhicule et qu’il soupçonne que vous êtes en état
                d’ébriété, celui-ci a le droit de vous demander de souffler dans
                un alcootest et d’obtenir un échantillon de votre haleine.
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Est-ce illégale de ne pas souffler dans l’alcootest"
                    alt=""
                />
            </p>
            <p>
                La première chose à savoir dans cette situation est que cette
                demande n’est pas simplement une suggestion. En effet, il s’agit
                bel et bien d’un ordre que vous vous devez de respecter.
            </p>
            <p>
                Par conséquent, si vous refusez d’obtempérer avec le policier et
                que vous ne passez pas l’alcootest, vous aurez automatiquement
                commis une infraction en vertu de l’article 320.15 du Code
                criminel.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Article 320.15.</strong> Comment une
                            infraction quiconque, sans que l’ordre a été donné,
                            omet ou refuse d’obtempérer à un ordre en vertu des
                            articles 320.27 ou 320.28.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Comme pour
                <Link to="https://avocatsalcoolauvolant.ca/consequences-alcool-volant/">
                    {' '}
                    l’infraction d’alcool au volant,{' '}
                </Link>
                l’infraction de refuser de passer l’alcootest aura certaines
                conséquences pouvant avoir des effets à long terme:
            </p>
            <ul>
                <li>Une contravention,</li>
                <li>Un casier judiciaire, ou</li>
                <li>Une suspension de permis.</li>
            </ul>
            <p>
                Le fait de refuser d’obtempérer a des c
                <strong>
                    onséquences similaires à la reconnaissance de culpabilité
                </strong>{' '}
                pour conduite en état d’ébriété. Mieux vaut souffler que de
                refuser.
            </p>
            <h3>
                <strong>
                    Quels sont les éléments permettant de démontrer votre
                    culpabilité?
                </strong>
            </h3>
            <p>
                Pour être reconnu coupable d’avoir refusé de souffler dans un
                alcootest, le procureur aura le fardeau d’en faire la preuve.
                Tout d’abord, il est nécessaire que vous ayez reçu l’ordre de
                souffler dans l’alcootest de manière claire.
            </p>
            <p>
                À chaque fois que le policier vous ordonne d’effectuer ce test,
                il doit démontrer qu’il avait des motifs raisonnables de
                soupçonner que vous avez consommé de l’alcool avant de prendre
                le volant.
            </p>
            <p>
                Le procureur devra prouver que vous avez conduit votre
                automobile d
                <strong>
                    ans les 3 heures qui précèdent votre arrestation
                </strong>
                . Finalement, il doit prouver que vous avez refusé de souffler
                dans l’alcootest.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Pas si vite! </strong>Vous pourriez
                            également être reconnu coupable de cette infraction
                            si le procureur prouver que vous aviez l’intention
                            de refuser de souffler ou de ne pas obtempérer avec
                            l’ordre du policier.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Le procureur devra aussi démontrer que vous avez bel et bien
                refusé d’obtempérer lorsque le juge vous a demandé de souffler
                dans l’alcootest.
            </p>
            <p>
                <strong>
                    Trouvez l’avocat qu’il vous faut dès aujourd’hui grâce au
                    formulaire en ligne d’Avocats Alcool au Volant!
                </strong>
            </p>
            <h2>
                <strong>
                    Quels sont les moyens de défense contre une accusation de
                    refus de souffler dans l’alcootest?
                </strong>
            </h2>
            <p>
                Si vous êtes accusé d’avoir refusé d’obtempérer avec l’ordre du
                policier, tout n’est pas perdu pour autant.{' '}
                <strong>Même s’il s’agit d’un geste grave, </strong>il n’en
                reste pas moins que certains moyens de défense existent.
            </p>
            <h3>
                <strong>La violation de vos droits fondamentaux</strong>
            </h3>
            <p>
                Lorsque vous faites appel à un avocat, la première chose que ce
                dernier va faire est de vérifier si le policier a respecté les
                procédures. Dans L’un des cas suivants,:{' '}
            </p>
            <ul>
                <li>Fouilles abusives,</li>
                <li>
                    Violation de vos droits fondamentaux (le droit à un avocat
                    par exemple), et
                </li>
                <li>
                    Le non-respect des procédures (et des délais) judiciaires.
                </li>
            </ul>
            <p>
                Si l’avocat est en mesure de démontrer une violation de vos
                droits, il est probable que le juge mette un terme aux
                procédures portées contre vous. Cependant, il faut s’assurer
                d’avoir un dossier complet et toutes les preuves nécessaires.
            </p>
            <h3>
                <strong>Votre condition médicale</strong>
            </h3>
            <p>
                Dans certains cas, les conditions médicales d’une personne
                peuvent justifier le refus de souffler dans l’alcootest. Cela
                sera notamment le cas si vous souffrez d’asthme ou d’un autre
                problème respiratoire.
            </p>
            <p>
                Toutefois, bien que cela justifie le fait que vous n’ayez pas
                soufflé dans l’alcootest, il est tout de même possible que vous
                soyez reconnu coupable d’avoir conduit avec les facultés
                affaiblies.
            </p>
            <h3>
                <strong>L’appareil de détection est non-conforme</strong>
            </h3>
            <p>
                Il est absolument nécessaire que l’appareil que le policier
                utilisé pour prélever votre haleine{' '}
                <strong>soit un appareil de détection approuvé</strong>. Si ce
                dernier ne respecte pas les exigences imposées par la loi, il
                est probable que la preuve soit automatiquement exclue.
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Que faire si je suis accusé d’avoir refusé de souffler dans l’alcootest?"
                    alt=""
                />
            </p>
            <p>
                De plus, le policier qui va prélever votre haleine doit avoir
                suivi une formation et être accrédité afin de pouvoir utiliser
                l’alcootest. Sinon, la procédure sera jugée non conforme et vous
                pourrez être exonéré.
            </p>
            <p>
                Cette formation doit être renouvelée à plusieurs reprises et le
                policier doit suivre des formations continues.{' '}
            </p>
            <h2>
                <strong>
                    Refus de passer un alcootest: Quelles sont les conséquences?
                </strong>
            </h2>
            <p>
                Si vous aviez l’intention de refuser de respecter l'ordre afin
                d’échapper aux conséquences de l’alcool au volant, cela n’est
                pas une bonne idée. En effet, votre sanction sera encore plus
                grave que si vous aviez un taux d’alcoolémie supérieur à 80 mg
                d’alcool par 100 ml de sang.
            </p>
            <p>
                Voici toutes les conséquences que vous pourriez subir si vous
                refusez de souffler dans l’alcootest au Québec:
            </p>
            <h3>
                <strong>1) Avoir un casier judiciaire</strong>
            </h3>
            <p>
                Lorsque vous êtes coupable d’avoir refusé de souffler dans un
                alcootest,{' '}
                <strong>vous aurez automatiquement un casier judiciaire</strong>
                . Bien que ce casier peut ne pas avoir de conséquences
                immédiates pour vous, il est important de comprendre ce que cela
                implique.
            </p>
            <p>
                Par exemple, si vous souhaitez vous{' '}
                <Link to="https://avocatsalcoolauvolant.ca/voyager-etats-unis-alcool-volant/">
                    déplacer à l'extérieur du pays
                </Link>
                , votre casier judiciaire pourrait venir chambouler vos plans.
                Cela est également le cas dans plusieurs autres aspects de votre
                vie.
            </p>
            <h3>
                <strong>2) La saisie de votre véhicule</strong>
            </h3>
            <p>
                Avant d’être reconnu coupable d’avoir refusé d’obtempérer avec
                l’ordre du policier qui vous a intercepté, ce dernier peut{' '}
                <strong>saisir votre véhicule</strong> pour une durée de 30
                jours, et ce, même sans le verdict d’un juge.
            </p>
            <p>
                <strong>Le saviez-vous?</strong> Si vous n’en êtes pas à votre
                première infraction de la sorte dans les 10 dernières années,
                l’agent de la paix pourra alors automatiquement saisir votre
                véhicule pour une durée de 90 jours.
            </p>
            <h3>
                <strong>3) Le paiement d’une contravention</strong>
            </h3>
            <p>
                En plus de la saisi de votre véhicule, vous allez recevoir une
                contravention minimale de 1 000 $ lorsque vous conduisez avec
                les facultés affaiblies.{' '}
            </p>
            <p>
                Cependant, si vous avez refusé de souffler dans l’alcootest,{' '}
                <strong>la contravention minimale sera alors de 2 000$</strong>,
                soit le double. De plus, ce montant minimal ne s’applique que
                dans le cas de votre première infraction. S’il s’agit d’une
                récidive, la sanction minimale sera également une peine
                d’emprisonnement.
            </p>
            <table>
                <tr>
                    <td>
                        <p>Infraction</p>
                    </td>
                    <td>
                        <p>Sanction minimale</p>
                    </td>
                    <td>
                        <p>Interdiction de conduire</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Première</p>
                    </td>
                    <td>
                        <p>2 000$ en amende</p>
                    </td>
                    <td>
                        <p>1 an</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Deuxième</p>
                    </td>
                    <td>
                        <p>Peine d’emprisonnement: 30 jours</p>
                    </td>
                    <td>
                        <p>2 ans</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Troisième</p>
                    </td>
                    <td>
                        <p>Peine d’emprisonnement: 120 jours</p>
                    </td>
                    <td>
                        <p>3 ans</p>
                    </td>
                </tr>
            </table>
            <h3>
                <strong>4) La suspension de votre permis</strong>
            </h3>
            <p>
                Finalement, si vous refusez de souffler dans l’alcootest, votre
                permis de conduire sera automatiquement{' '}
                <strong>suspendu pour une durée de 90 jours</strong>. Le juge
                peut néanmoins révoquer votre permis pour une période
                additionnelle.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Quelle est la différence entre l’infraction d’alcool au volant et le refus de souffler dans l’alcootest?"
                    alt=""
                />
            </p>
            <p>
                Le juge peut aussi vous obliger à avoir un antidémarreur
                éthylométrique. Dans ce cas, il sera nécessaire de souffler dans
                le détecteur afin de pouvoir prendre le volant.
            </p>
            <p>
                Pour que votre véhicule puisse démarrer, vous devez avoir{' '}
                <strong>une absence complète d’alcool dans votre sang</strong>.
                Une telle sanction peut aussi être accompagnée d’une adhésion
                obligatoire au Programme d’évaluation et de réduction des
                risques de conduite avec les facultés affaiblies.
            </p>
            <p>
                <strong>
                    Minimiser les conséquences de votre refus de souffler en
                    faisant appel à un avocat spécialisé en alcool au volant!
                </strong>
            </p>
            <h2>
                <strong>
                    Défendez-vous grâce à un avocat partenaire d’Avocats Alcool
                    au Volant
                </strong>
            </h2>
            <p>
                Être reconnu coupable d’avoir commis une infraction en lien avec
                l’alcool au volant est souvent associé à de très lourdes
                conséquences. Cela est d’autant plus vrai si vous avez tout
                simplement refusé d’obtempérer avec le policier qui souhaite
                vous soumettre à un alcootest.
            </p>
            <p>
                Selon votre situation, il est possible que vous ne connaissiez
                pas les différents moyens de défense mis à votre disposition. De
                plus, avec le stress associé aux accusations portées contre
                vous, vous n’êtes peut-être pas la meilleure personne pour
                assurer votre défense.
            </p>
            <p>
                Heureusement, il vous est possible de
                <Link to="https://avocatsalcoolauvolant.ca/avocat-criminel-alcool-volant/">
                    {' '}
                    trouver un avocat
                </Link>{' '}
                qui spécialise sa pratique dans les défenses contre les
                accusations d’alcool au volant ou les infractions de refus de
                souffler dans l’alcootest.
            </p>
            <p>
                <strong>
                    N’attendez plus et remplissez dès maintenant le formulaire
                    en ligne d’Avocats Alcool au Volant pour trouver le
                    professionnel qu’il vous faut!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "refus-souffler-alcootest/refus-echantillon-haleine.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "refus-souffler-alcootest/consequences-refus-souffler.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "refus-souffler-alcootest/defense-refus-alcootest.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "refus-souffler-alcootest/alcool-volant-test.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
